import React from "react";
import { Calendar } from "lucide-react";
import { Constants } from "../utils/constants";

const HUserSection = () => {
  return (
    <div>
      <div className="flex items-start gap-3">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR }}
        >
          <Calendar className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <div className="text-gray-900 font-medium mb-1">John Deo</div>
          <div className="text-gray-500 text-sm">Busy – Default visibility – notify 30 minutes before</div>
        </div>
      </div>
    </div>
  );
};

export default HUserSection;
